import ActionTypes from "./ActionTypes";
import Dispatcher from "./Dispatcher";

export default {
  /** Fake login: USE only in storybook preview */
  mockLogin(token) {
    Dispatcher.dispatch({
      actionType: ActionTypes.JWT_LOGIN_COMPLETED,
      token,
    });
  },

  confirmAuthentication() {
    Dispatcher.dispatch({
      actionType: ActionTypes.CONFIRM_AUTHENTICATION,
    });
  },

  logout() {
    Dispatcher.dispatch({
      actionType: ActionTypes.LOGOUT,
    })
  }
}
